import {Component, OnInit} from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { WatchlistApplicationState } from '../store/watchlist-state';
import { SetCurrentUserAction } from '../store/actions/SetCurrentUserAction';
import { MainStoreService } from '@nw/ui-core-shared/store/main-store.service';
import { IotHandlerService } from '../shared/services/iot-handler.service';

@Component({
    selector   : 'nw-watchlist',
    templateUrl: './watchlist.component.html',
    styleUrls  : ['./watchlist.component.scss']
})

export class WatchlistComponent implements OnInit {

    pageTitle: string;

    constructor(private store: Store<WatchlistApplicationState>,
                private mainStoreService: MainStoreService,
                private iotHandlerService: IotHandlerService,
                private translateService: TranslateService) {
    }

    ngOnInit() {
        this.mainStoreService.getStore().select(state => state.appPrincipal)
            .subscribe(principal => {
                this.store.dispatch(new SetCurrentUserAction(principal.getUserId()));
                this.iotHandlerService.initIotHandler();

                const plId = principal.getClassicRuntimeData().plId ? principal.getClassicRuntimeData().plId : '1';

                const lang = (plId === '29') ? principal.language : 'en';

                this.translateService.setDefaultLang(lang);
                this.translateService.use(lang);

            });
    }
}

/* istanbul ignore next */




// WEBPACK FOOTER //
// ./node_modules/@nw/ui-watchlist/components/watchlist.component.ts